import type Eshop from '@eshop/type/eshop'

import css from './index.module.css'

import { ProductPriceHelper } from '#/global/helper/Product/ProductPriceHelper'

interface Props {
    product: Eshop.Product<'detail' | 'price'>
}

export const ProductDiscount = ({ product }: Props) => {
    if (!ProductPriceHelper.hasDiscount(product)) {
        return null
    }

    if (!ProductPriceHelper.isDiscountPercentVisible(product)) {
        return null
    }

    const discount = ProductPriceHelper.getDiscountPercent(product)
    
    const getColor = () => {
        return ProductPriceHelper.hasDiscountPromo(product) ? css.discountYellow : ''
    }

    return (
        <div className={`r-product-discount ${css.discount} ${getColor()}`.trim()}>
            <div>
                -
                {' '}
                {discount}
                {' '}
                %
            </div>
        </div>
    )
}
